import { render, staticRenderFns } from "./loanMarketAdvue.vue?vue&type=template&id=7a156fdd&scoped=true&"
import script from "./loanMarketAdvue.vue?vue&type=script&lang=js&"
export * from "./loanMarketAdvue.vue?vue&type=script&lang=js&"
import style0 from "./loanMarketAdvue.vue?vue&type=style&index=0&id=7a156fdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a156fdd",
  null
  
)

export default component.exports